<template>

    <Transition :name="isDesktop || !openMobileMenuTransition ? '' : 'slide-vertical'">
    <div v-show="openMobileMenu || isDesktop" id="epa_sidebar" :class="[stickyClass]">
        <ul class="menu" ref="menuElement">
            <li v-for="item in menuItems"
                :class="`menu_item ${route().current(item.route) ? 'active':''}`"
                @click.prevent="() => { openMobileMenu = false; router.visit(route(item.route)) }">
                <EpaIcon :icon="item.icon"/>
                {{ $t(item.label) }}
            </li>
            <li v-if="isSuperAdmin" v-for="item in menuItemsSuperAdmin"
                :class="`menu_item ${route().current(item.route) ? 'active':''}`"
                @click.prevent="() => { openMobileMenu = false; router.visit(route(item.route)) }">
                <EpaIcon :icon="item.icon"/>
                {{ $t(item.label) }}
            </li>
        </ul>

        <ul class="bottommenu menu">
            <li v-if="isSuperAdmin" class="menu_item" @click.prevent="router.visit(route('nova.login'))" >
                <EpaIcon icon="admin"/>
                {{ $t('Admin') }}
            </li>
        </ul>
    </div>
    </Transition>

</template>

<script setup>
import {router, usePage} from '@inertiajs/vue3';
import {ref, onMounted, onUpdated, onUnmounted, computed} from 'vue';
import EpaIcon from "../UI/EpaIcon.vue";
import { openMobileMenu, openMobileMenuTransition } from  '../../Functions/Functions.ts'

const page = usePage();
const isSuperAdmin = computed(() => page.props.auth.user?.data?.super_admin);

const menuItems = [
    {
        'route': 'dashboard',
        'label': 'Dashboard',
        'icon': 'dashboard'
    },
    {
        'route': 'survey.index',
        'label': 'Surveys',
        'icon': 'surveys'
    },
    {
        'route': 'results',
        'label': 'Results',
        'icon': 'results'
    },
    {
        'route': 'logout',
        'label': 'Logout',
        'icon': 'logout'
    },
];

const menuItemsSuperAdmin = [
    {
        'route': 'dashboard.admin',
        'label': 'Admin Dashboard',
        'icon': 'dashboard'
    }
];


const menuElement = ref(null);
const stickyClass = ref('');

const isDesktop = ref(window.innerWidth >= 1229);

const checkResize = () => {

    isDesktop.value = window.innerWidth >= 1229;

    if (menuElement.value)
    {
        const menuHeight = menuElement.value.offsetHeight;
        const windowHeight = window.innerHeight - 100;

        if( windowHeight > menuHeight )
        {
            stickyClass.value = '';
            return;
        }
    }
    stickyClass.value = 'not_sticky';
};

onMounted(() => {
    checkResize();
    window.addEventListener('resize', checkResize);
});

onUnmounted(() => {
    window.removeEventListener('resize', checkResize);
});

onUpdated(() => {
    checkResize();
});



</script>

<style scoped lang="scss">

#epa_sidebar {
    background-color: $sidebar-background-color;
    color: $sidebar-text-color;
    display: grid;

    .menu {
        display: grid;
        gap: 0;
        height: fit-content;
        padding: 0;
        margin: 0;
        position: sticky;
        top: 0;

        .menu_item {
            border-left: 0.2rem solid transparent;
            padding: 3rem;
            transition: 300ms;
            width: 100%;
            list-style: none;
            display: flex;
            align-items: center;
            gap: 1rem;
            cursor: pointer;

            svg {
                width: 2.2rem;
                margin-top: -0.4rem;

                path {
                    fill: #fff;
                }
            }

            &.active,
            &:hover {
                border-left: 0.2rem solid $active-menu-item-color;
                background-color: $sidebar-background-color-hover;

                svg {
                    color: $accent-color;
                }
            }
        }
    }

    .bottommenu {
        margin-top: auto;
        top: auto;
        bottom: 0;
        background-color: $sidebar-background-color;
    }

    &.not_sticky {

        .menu:not(.bottommenu) {
            position: static;
        }
    }
}



.slide-vertical-enter-active,
.slide-vertical-leave-active {
    transition: max-height 0.3s ease, opacity 0.3s ease;
    overflow: hidden;
}

.slide-vertical-enter-from,
.slide-vertical-leave-to {
    max-height: 0;
    opacity: 0;
}

.slide-vertical-enter-to,
.slide-vertical-leave-from {
    max-height: 500px;
    opacity: 1;
}

.sidebar-content {
    background: white;
    border-right: 1px solid #eee;
}

</style>
